<template>
    <div class="main">
        <admin-navigation></admin-navigation>
        <div class="content-area" v-if="emptyState">
            <div class="page-header">
                <div class="page-details">
                    <h2>Missing Punch Requests</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/missing-punch-requests'" class="current">Missing Punch Requests</router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <div class="searchbar">
                    <form id="getFilterDataform" action="#">
                        <div class="internalSearchBar">
                            <input class="employeeSearchBar" type="text" name="search" v-model="filterForm.search" placeholder="Search for Employees" @keyup="applyFilter" />
                        </div>
                        <div class="filters">
                            <div class="filter">
                                <div class="filter__header">
                                    <VueDatePicker v-model="filterForm.date" :color="admin_color" @onChange="applyFilter"><i class="fa fa-calendar-week" /></VueDatePicker>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Location</span><span class="filter__value">All</span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" v-for="location in locations" @click="filterLocationsCheckbox" :data-id="location.id">
                                        <input type="checkbox" name="location_id[]" :value="location.id" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">{{location.name}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Tags</span><span class="filter__value">All</span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" v-for="tag in tags" @click="filterTagsCheckbox" :data-id="tag.id">
                                        <input type="checkbox" name="tag_id[]" :value="tag.id" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">{{ tag.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter--reset">
                                <a href="#" @click.prevent="resetFilter"> Reset Filter</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="section mt-3 no-bg">
                <data-table :ajax="requestsAjax" :columns="requestsColumns" :order="0"></data-table>
            </div>
        </div>
        <div class="content-area" v-if="!emptyState">
            <div class="page-header">
                <div class="page-details">
                    <h2>Detailed Report</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/missing-punch-requests'" class="current">Missing Punch Requests</router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section no-bg">
                <div class="empty-state mt-5">
                    <img :src="base_url + '/admin/img/noEmployees.svg'" />
                    <h5>No Data</h5>
                    <p>
                        Looks like there are no records
                    </p>
                </div>
            </div>
        </div>

        <div class="modal fade" id="manageRequestModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-show="acceptRequestFlag" id="exampleModalLabel">Accept Missing Punch Request</h5>
                        <h5 class="modal-title" v-show="!acceptRequestFlag" id="exampleModalLabel">Reject Missing Punch Request</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form action="#" id="manageRequestForm" @submit.prevent="updateRequest">
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="">Comment</label>
                                <textarea class="form-control" v-model="manageRequestForm.comment"></textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
export default {
    data() {
        return {
            emptyState: true,
            requestsAjax: {},
            requestsColumns: [],
            tags: {},
            locations: {},
            filterForm: new Form({
                date: null,
                search: "",
                locations: [],
                tags: []
            }),
            acceptRequestFlag: true,
            manageRequestForm: new Form({
                id: "",
                action: "accept",
                comment: ""
            })
        }
    },
    validations: {
    },
    created() {
        this.getTags();
        this.getLocations();
        this.loadDataTableDetails();
        this.manageRequest();
    },
    methods: {
        getTags() {
            axios.get("/api/admin/tags").then(response => {
                this.tags = response.data.data;
            });
        },
        getLocations() {
            axios.get("/api/admin/locations").then(response => {
                this.locations = response.data.data.records;
            });
        },
        filterLocationsCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedLocations = this.filterForm.locations;
            this.filterForm.locations = this.setCheckedCheckboxes(currentTargetValues, checkedLocations);
            this.applyFilter();
        },
        filterTagsCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedTags = this.filterForm.tags;
            this.filterForm.tags = this.setCheckedCheckboxes(currentTargetValues, checkedTags);
            this.applyFilter();
        },
        setCheckedCheckboxes(currentTargetValues, checkedOptions) {
            if (currentTargetValues.getAttribute("data-active") && currentTargetValues.getAttribute("data-id")) {
                if (currentTargetValues.getAttribute("data-active") == "false") {
                    checkedOptions.push(currentTargetValues.getAttribute("data-id"));
                } else {
                    var index = checkedOptions.indexOf(currentTargetValues.getAttribute("data-id"));
                    if (index !== -1) {
                        checkedOptions.splice(index, 1);
                    }
                }
            }
            return checkedOptions;
        },
        applyFilter() {
            this.refreshDataTable();
        },
        resetFilter() {
            this.filterForm.clear();
            this.filterForm.reset();
            this.refreshDataTable();
        },
        loadDataTableDetails() {
            this.requestsAjax = {
                url: `/api/admin/missing-punches-grid`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },
            };

            this.requestsColumns = [
                { name: 'ID', data: 'id', orderable: true, searchable: true },
                { name: 'Employee', data: 'employee_name', orderable: true, searchable: true },
                { name: 'Action', data: 'action_type', orderable: true, searchable: true },
                { name: 'Time', data: 'action_time', orderable: true, searchable: true },
                { name: 'action_date', data: 'action_date', orderable: true, searchable: true },
                { name: 'Location', data: 'location_name', orderable: true, searchable: true },
                { name: 'Status', data: 'acceptance', orderable: true, searchable: true },
                {
                    name: 'Actions',
                    data: null,
                    render(data, type, row, meta) {
                        let html = "";
                        if(data.status == 1) {
                            html = `
                                <div class="action-bar">
                                    <a href="javascript:;" title="Accept request" data-id="${data.id}" class="accept-request"><img style="width:24px;height:24px;" src="/admin/img/accepted.svg" /></a>
                                    <a href="javascript:;" title="Reject request" data-id="${data.id}" class="reject-request"><img style="width:24px;height:24px;" src="/admin/img/rejected.svg" /></a>
                                </div>
                            `;
                        }
                        return html;
                    },
                },
            ];
        },
        refreshDataTable() {

            let locationsFilter = this.filterForm.locations.toString();
            let tagsFilter = this.filterForm.tags.toString();

            let filters = `search_data=${this.filterForm.search}&locations=${locationsFilter}&tags=${this.filterForm.tags}&date=${this.filterForm.date}`;

            this.requestsAjax = {
                url: `/api/admin/missing-punches-grid?${filters}`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },
            };

            let options = {
                ajax: this.requestsAjax,
                scrollY: false,
                scrollX: true,
                serverSide: true,
                searching: false,
                dom: '<"top">rt<"bottom"<"left-actions"li>p><"clear">',
                columnDefs: [],
                select: {
                    style: "os",
                    selector: "td:first-child",
                },
                order: [[0, "desc"]],
                columns: this.requestsColumns,
            };

            $(".user-datatable").DataTable().destroy();

            $(".user-datatable").DataTable(options).draw();
        },
        manageRequest() {
            let vuejs = this;
            $(document).on("click", ".accept-request", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                vuejs.manageRequestForm.clear();
                vuejs.manageRequestForm.reset();
                vuejs.acceptRequestFlag = true;
                vuejs.manageRequestForm.id = id;
                $("#manageRequestModal").modal("show");
            });
            $(document).on("click", ".reject-request", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                vuejs.manageRequestForm.clear();
                vuejs.manageRequestForm.reset();
                vuejs.acceptRequestFlag = false;
                vuejs.manageRequestForm.id = id;
                vuejs.manageRequestForm.action = "reject";
                $("#manageRequestModal").modal("show");
            });
        },
        updateRequest() {
            axios({
                method: "post",
                url: `/api/admin/missing-punches/manage-request`,
                data: this.manageRequestForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageRequestModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.refreshDataTable();
                } else {
                    Toast.fire({ icon: 'error', title: response.data.message });
                }
            }, (error) => {
                console.log(error)
            });
        }
    },
}

</script>
